import Layout from "@/components/Layout";

const Privacy = () => (
  <Layout>
    <div className="container mx-auto max-w-2xl px-4 py-10 space-y-6 text-slate-200">
      <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
      <p className="text-sm text-slate-400">Last updated: March 2026</p>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">What we collect</h2>
        <ul className="list-disc pl-5 space-y-1 text-sm text-slate-300">
          <li>Your account email address (used for authentication).</li>
          <li>Search keywords and selected evidence sources you provide when generating a report.</li>
          <li>Amazon review text you paste into the tool (if provided).</li>
          <li>Generated reports and associated metadata.</li>
          <li>Basic usage logs and error data to keep the service running.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">What we don't want</h2>
        <p className="text-sm text-slate-300">
          Please <strong className="text-white">do not</strong> paste personal data — names, email addresses, physical addresses or phone numbers — into the review text box. The tool is designed to process product reviews, not personal information.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">How we use your data</h2>
        <ul className="list-disc pl-5 space-y-1 text-sm text-slate-300">
          <li>To generate and store your reports.</li>
          <li>To improve reliability and fix errors.</li>
          <li>To provide support if you contact us.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Third parties</h2>
        <p className="text-sm text-slate-300">We use the following third-party services:</p>
        <ul className="list-disc pl-5 space-y-1 text-sm text-slate-300">
          <li><strong className="text-white">Authentication &amp; database provider</strong> — stores your account and report data securely.</li>
          <li><strong className="text-white">Firecrawl</strong> — scrapes public web pages to gather evidence for reports.</li>
          <li><strong className="text-white">Google OAuth</strong> — optional sign-in via your Google account.</li>
          <li><strong className="text-white">Google Forms</strong> — linked for optional user feedback.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Data retention</h2>
        <p className="text-sm text-slate-300">
          Reports are stored for up to 12 months. You may request deletion of your data at any time by contacting us (see below).
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Your rights</h2>
        <p className="text-sm text-slate-300">
          You can request deletion of your account and all associated data by emailing <a href="mailto:dawnrebecca@live.co.uk" className="text-blue-400 hover:text-blue-300 underline">dawnrebecca@live.co.uk</a>. We will process requests within 30 days.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Cookies &amp; session storage</h2>
        <p className="text-sm text-slate-300">
          We use authentication cookies and browser local storage solely to keep you signed in. We do not use tracking or advertising cookies.
        </p>
      </section>
    </div>
  </Layout>
);

export default Privacy;
